__turbopack_context__.v({
  "content": "gW2l0W_content",
  "videoBanner": "gW2l0W_videoBanner",
  "videoBannerWrapper": "gW2l0W_videoBannerWrapper",
  "videoTopWrapper": "gW2l0W_videoTopWrapper",
  "videoWrapper": "gW2l0W_videoWrapper",
});
